import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { useMemo } from "react";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  status: number | null;
  situacao: number | null;
  nomeDescricao: string | null;
  dataVencimento: (Date | null)[] | null;
  onStatusChange: (status: number | null) => void;
  onSituacaoChange: (situacao: number | null) => void;
  onNomeDescricaoChange: (nomeDescricao: string | null) => void;
  onDataVencimentoChange: (dataVencimento: (Date | null)[] | null) => void;
  onClearFilter: () => void;
};

export const Header = ({
  status,
  situacao,
  nomeDescricao,
  dataVencimento,
  onStatusChange,
  onSituacaoChange,
  onNomeDescricaoChange,
  onDataVencimentoChange,
  onClearFilter,
}: Props) => {

  const statusOptions = useMemo(() => {
    return [
      {
        id: 2,
        label: 'Todos',
      },
      {
        id: 1,
        label: 'Atual',
      },
      {
        id: 0,
        label: 'Obsoleto',
      },
    ];
  }, [
  ]);

  const situacaoOptions = useMemo(() => {
    return [
      {
        id: 2,
        label: 'Todos',
      },
      {
        id: 1,
        label: 'Em dia',
      },
      {
        id: 0,
        label: 'Vencido',
      },
    ];
  }, [
  ]);

  return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
          <DefaultSelectInput
            name="status"
            label="Status"
            showSelectionLabel={false}
            options={statusOptions}
            value={status}
            onChangeValue={e => onStatusChange(e !== null && e !== undefined && e.trim().length !== 0 ? Number(e) : null)}
          />

          <DefaultSelectInput
            name="situacao"
            label="Situação"
            showSelectionLabel={false}
            options={situacaoOptions}
            value={situacao}
            onChangeValue={e => onSituacaoChange(e !== null && e !== undefined && e.trim().length !== 0 ? Number(e) : null)}
          />

          <DefaultInput
            name="nomeDescricao"
            label="Nome/Descrição"
            value={nomeDescricao}
            onChangeValue={e => onNomeDescricaoChange(e !== null && e !== undefined && e.trim().length !== 0 ? e : null)}
          />

          <DefaultDateRangePickerInput
            label="Data de Vencimento"
            dataDe={dataVencimento?.[0] ?? null}
            dataAte={dataVencimento?.[1] ?? null}
            onChange={(de, ate) => {
              if (de !== null && ate !== null) {
                onDataVencimentoChange([de, ate]);
              }
              else if (de !== null) {
                onDataVencimentoChange([de, null]);
              }
              else if (ate !== null) {
                onDataVencimentoChange([null, ate]);
              }
              else {
                onDataVencimentoChange(null);
              }
            }}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilter}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}